import { CustomClaims, UserType } from '../contexts/authContext'
import { firebaseAuth } from './firebase'

export const getCustomClaims = async () => {
  const claims: CustomClaims = {
    userType: UserType.vendor
  }

  const idTokenResult = await firebaseAuth().currentUser?.getIdTokenResult(true)

  if (idTokenResult?.claims.vendorId && idTokenResult?.claims.role) {
    claims.vendorId = idTokenResult?.claims.vendorId as string
    claims.role = {
      id: idTokenResult?.claims.role?.id as string,
      name: idTokenResult?.claims.role?.name as string,
      permissions: idTokenResult?.claims.role?.permissions
    }
  }

  return claims
}
